import * as React from "react";
import { observer } from "mobx-react-lite";
import { LoaderBox } from "src/components/LoaderBox";
import { onError } from "src/common/onError";
import { Bom3PositionStore } from "../Bom3PositionsStore";
import { Bom3PositionsTable } from "../Bom3PositionsTable";

type PropsBom3PositionsTableBox = {
  store: Bom3PositionStore;
};

export const Bom3PositionsTableBox: React.FC<PropsBom3PositionsTableBox> =
  observer(({ store }) => {
    React.useEffect(() => {
      store.init().catch(onError);
    }, [store]);
    return (
      <LoaderBox
        remoteData={store.data}
        drawReady={() => <Bom3PositionsTable store={store} />}
      />
    );
  });
